/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

// Created/Modified by GitHub Copilot (GPT-5.4) on 2026-09-22 by lalitkumar_sonje
// Redirect the home route to a configured custom homepage while keeping the default welcome page on /home.

import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { SidebarService } from '../../layout/sidebar/services/sidebar.service';
import { LeftNavigationMenu } from '../../layout/sidebar/models/navigation-menu-item';

const DEFAULT_WELCOME_PAGE_LINK =
  'wcf?name=general-view-aui-wrapper&viewId=system:administration_home.159';

@Injectable({
  providedIn: 'root',
})
export class HomePageRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private sidebarService: SidebarService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.sidebarService.getSidebarItems().pipe(
      take(1),
      map((leftMenu: LeftNavigationMenu) => {
        const configuredHomePage = leftMenu?.homepage?.link?.trim();

        if (
          !configuredHomePage ||
          configuredHomePage === 'home' ||
          configuredHomePage === DEFAULT_WELCOME_PAGE_LINK
        ) {
          return true;
        }

        const normalizedLink = configuredHomePage.startsWith('/')
          ? configuredHomePage
          : `/${configuredHomePage}`;

        return this.router.parseUrl(normalizedLink);
      }),
      catchError(() => of(true))
    );
  }
}